export enum FilterSetType {
  None = "None",
  Activity = "Activity",
  DivisionAndDelegation = "DivisionAndDelegation",
  Sector="Sector",
  Language="Language",
  GeographicalLocation="GeographicalLocation"
}

export interface FilterInterface {
  spId: string;
  parentCode: string | null;
  translation: string;
  filters?: FilterInterface[];
  customProperties?: { [key: string]: string };
}

export interface FilterInterfaceLight {
  spId: string;
  filters?: FilterInterfaceLight[];
  customProperties?: { [key: string]: string };
}

export interface FilterSet {
  spId: string;
  localName: string;
  filterSetType: FilterSetType;
  filters: FilterInterface[];
  filtersCategories: FilterInterface[];
}

export interface FilterSetLight {
  spId: string;
  filterSetType: FilterSetType;
  filters: FilterInterfaceLight[];
  filtersCategories: FilterInterfaceLight[];
}

export interface FilterGroup {
  spId: string;
  filterSets: FilterSet[]
}